import { render, staticRenderFns } from "./OxygenVariablesInput.vue?vue&type=template&id=a6afb6aa&"
import script from "./OxygenVariablesInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenVariablesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports